import { createAction, props } from '@ngrx/store';

export const showLoaderUntil = createAction(
  '[Loader] Show Loader Until',
  props<{ actionType: string }>()
);

export const resetState = createAction('[Loader] Reset State');
